import React, { useContext } from 'react';
import invisible from '../../images/invisible.svg';
import { EditorContext } from './EditorContext';

const EntryContent: React.FunctionComponent = () => {
  const { state, dispatch } = useContext(EditorContext);
  const { content } = state.input;

  return (
    <>
      <div className="flex-none flex justify-between items-center mt3 mb3">
        <p className="flex items-center f8 serif i mv0">
          <img
            src={invisible}
            style={{ width: 18, height: 16 }}
            className="db mr2"
            alt="Only visible to you"
          />
          Only you can see this note
        </p>
        <p className="f8 serif i moon-gray mv0">You can use Markdown here</p>
      </div>

      <div className="bg-near-white br2 mb4" style={{ height: '40vh' }}>
        <textarea
          className="bg-transparent w-100 sans-serif flex-auto pa3 lh-copy bn"
          style={{ resize: 'none', minHeight: 180 }}
          name="Content"
          value={content}
          placeholder="Note to self..."
          onChange={(event: React.SyntheticEvent) => {
            const target = event.target as HTMLTextAreaElement;
            dispatch({
              type: 'updateContent',
              value: target.value
            });
          }}
          data-testid="quala-editor-note-input"
        />
      </div>
    </>
  );
};

export default EntryContent;
